
import { Breadcrumb, Col, Container, Row } from "react-bootstrap";

import BreadcrumbItem from '../components/BreadcrumbItem';
import data from "../data/privacy-policy.json";

export async function getStaticProps() {
  return {
    props: {
      nav: {
        light: true,
        classes: "shadow",
        color: "white",
      },
      canonical: `${process.env.BASE_URL}/privacy-policy`,
      title: data.title,
      meta: data.meta,
    },
  }
}

const Terms = (props) => {
  return (
    <>
      <section className="hero py-5 py-lg-7">
        <Container className="position-relative">
          <Breadcrumb listProps={{ className: "ps-0 justify-content-center" }}>
            <BreadcrumbItem href="/">Home</BreadcrumbItem>
            <BreadcrumbItem active>{props.title}</BreadcrumbItem>
          </Breadcrumb>
          <h1 className="hero-heading">{data.title}</h1>
          <p className="text-muted">{data.subtitle}</p>

        </Container>
      </section>
      <section className="py-6">
        <Container>
          <Row>
            <Col xl="8" lg="10" className="mx-auto">
              <p className="text-muted mb-5" dangerouslySetInnerHTML={{ __html: data.description }} />
              <div className="">
                {data.policyItems.map((item, idx) => (
                  <div key={idx} className="mb-5">

                    <h2 className="h3 mb-4">{item.title}</h2>
                    {item.content.map((block, bIdx) => {
                      if (block.title) {
                        return <h3 className="h5 mt-2 mb-4" key={bIdx}>{block.title}</h3>;
                      }
                      if (block.paragraph) {
                        return <p key={bIdx} className="text-muted mb-4" dangerouslySetInnerHTML={{ __html: block.paragraph }} />;
                      }
                      if (block.list) {
                        return (
                          <ul key={bIdx} className="mb-4">
                            {block.list.map((listItem, liIdx) => (
                              <li
                                key={liIdx}
                                className="text-muted"
                                dangerouslySetInnerHTML={{ __html: listItem }}
                              />
                            ))}
                          </ul>
                        );
                      }

                    })}
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Terms
